import { useQuery, useSuspenseQuery } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import { contractModificationSchema } from '../../../common/validations'

import { get } from 'api/apiClient'

const params = (uuid: string) => {
  const url = API_ENDPOINTS.CONTRACT_MODIFICATION_REQUEST.replace(':uuid', uuid)
  return {
    queryKey: [url],
    queryFn: () => get(url, contractModificationSchema),
  }
}

export const useAPIGetContractModificationRequest = (contractUUID: string) =>
  useQuery(params(contractUUID))

export const useAPIGetContractModificationRequestSuspense = (
  contractUUID: string
) => useSuspenseQuery(params(contractUUID))
